export const toNumber = (value, fallback = 0) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : fallback;
};

export const getCouponDiscountAmount = (coupon, subtotal) => {
  const normalizedSubtotal = Math.max(toNumber(subtotal), 0);

  if (!coupon || normalizedSubtotal <= 0) {
    return 0;
  }

  const rawCouponAmount =
    coupon.amount_type === 'A'
      ? Math.abs(toNumber(coupon.amount))
      : (normalizedSubtotal * Math.abs(toNumber(coupon.amount))) / 100;

  return Math.min(rawCouponAmount, normalizedSubtotal);
};

export const getPricingSummary = ({ totalPrice, baseDiscount = 0, coupon }) => {
  const normalizedTotalPrice = Math.max(toNumber(totalPrice), 0);
  const normalizedBaseDiscount = Math.min(
    Math.max(toNumber(baseDiscount), 0),
    normalizedTotalPrice
  );
  const subtotalAfterBaseDiscount = Math.max(
    normalizedTotalPrice - normalizedBaseDiscount,
    0
  );
  const couponDiscount = getCouponDiscountAmount(
    coupon,
    subtotalAfterBaseDiscount
  );
  const totalDiscount = Math.min(
    normalizedBaseDiscount + couponDiscount,
    normalizedTotalPrice
  );
  const discountedTotal = Math.max(normalizedTotalPrice - totalDiscount, 0);

  return {
    totalPrice: normalizedTotalPrice,
    baseDiscount: normalizedBaseDiscount,
    couponDiscount,
    totalDiscount,
    discountedTotal,
  };
};
